import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../components/layout/table-container/table-container";
import { distributorVersionList } from "../../redux/actions/distributorActions";
import DistributorVersionTableData from "./distributor-version-table-data";
import "./distributor.css";
import UpArrow from "../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../assets/icons/filterArrowDown.svg";
import LoadingSpinnerTable from "../../components/utilites/loaderSpinningContainer";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../components/Pagination/number-pagination";

const DistributorVersionTable = ({ search, page_no, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [distributorVesrionList, setDistributorVersionList] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      distributorVersionList(
        {
          page,
          search,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
        },
        onSuccess,
        onError
      )
    );
  }, [page, status, search, dispatch]);

  const onSuccess = (data) => {
    setDistributorVersionList(data.data.data);
    setLoading(false);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"10%"}>
              Distributor ID
            </th>
            <th className="table-heads " width={"10%"}>
              Distributor Name
            </th>
            <th className="table-heads text-center" width={"10%"}>
              No. of Orders
            </th>
            <th className="table-heads text-center" width={"15%"}>
              No. of Manufacturer
            </th>
            <th
              ref={componentRef}
              className="table-heads text-nowrap"
              width={"8%"}
            >
              <span
                className={
                  openStatus ? "Medium_Purple cursor_pointer" : "cursor_pointer"
                }
                onClick={() => setOpenStatus(!openStatus)}
              >
                <span className={status ? "Medium_Purple fw_700" : ""}>
                  Status
                </span>
                {openStatus ? (
                  <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                ) : (
                  <img src={DownArrow} className="mx-1" alt="v" />
                )}
              </span>
              {openStatus ? (
                <div className=" position-relative">
                  <div className="position-absolute status-container d-flex gap-3 px-3">
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="active"
                        name="status"
                        value={"active"}
                        checked={status === "active"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/distributors/distributor/version-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=active`
                          );
                        }}
                      />
                      <label
                        htmlFor="active"
                        className={
                          status === "active"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Active
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="inactive"
                        name="status"
                        value={"inactive"}
                        checked={status === "inactive"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/distributors/distributor/version-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=inactive`
                          );
                        }}
                      />
                      <label
                        htmlFor="inactive"
                        className={
                          status === "inactive"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Inactive
                      </label>
                    </div>
                    <button
                      className="filter-btn px-2 py-0 my-2 fs_12"
                      style={{ height: "28px" }}
                      onClick={() => {
                        setOpenStatus(!openStatus);
                        navigate(
                          `/distributors/distributor/version-list?page=1${
                            search ? `&search=${search}` : ""
                          }`
                        );
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              ) : null}
            </th>
            <th className="table-heads " width={"10%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : distributorVesrionList?.distributors?.length > 0 ? (
            <>
              {distributorVesrionList?.distributors?.map((eachRow, index) => (
                <DistributorVersionTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  currentPage={distributorVesrionList?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {distributorVesrionList?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={distributorVesrionList?.pagination?.currentPage}
            totalPages={distributorVesrionList?.pagination?.totalPages}
            path={"/distributors/distributor/version-list"}
            filters={`${queryString}`}
          />
        )}
      </div>
    </>
  );
};

export default DistributorVersionTable;
